<template>
  <VModal class="cash-receipt-wrapper" :type="ModalType.custom">
    <VBlock class="cash-receipt" :sort="Sort.center_top" :direction="Direction.column">
      <VBlock class="cash-receipt-header-wrapper" :direction="Direction.column">
        <VBlock class="cash-receipt-header" :sort="Sort.space_between">
          <VBlock class="stock-wrapper">
            <VStockButton :type="StockButtonType.exit" :clickEvent="onOK" :width="16" :height="16" />
          </VBlock>
          <VSpan class="text" text="현금영수증 보기" :size="16" :weight="TextWeight.bold" />
          <div class="blank"></div>
        </VBlock>
        <VBlock v-if="hasTab" class="cash-receipt-tab" :sort="Sort.center_center">
          <button
            class="tab-button"
            type="button"
            :class="{ active: receiptTabIndex === 0 }"
            @click="receiptTabIndex = 0"
          >
            주문금액
          </button>
          <button
            class="tab-button"
            type="button"
            :class="{ active: receiptTabIndex === 1 }"
            @click="receiptTabIndex = 1"
          >
            배달팁
          </button>
        </VBlock>
      </VBlock>

      <div class="cash-receipt-header-filler" :style="hasTab ? 'height:84px' : 'height:44px'" />
      <VBlock v-if="receiptTabContents.length > 0" :padding="[11, 16]" :direction="Direction.column">
        <VBlock class="field-row" v-for="(contents, index) in receiptEntryLines" :key="index">
          <VSpan class="title" :text="contents.title" :size="contentsFontSize" />
          <VSpan
            class="text"
            :type="index === 0 ? TextType.Number : TextType.String"
            :text="index === 0 ? `${contents.text}원` : contents.text"
            :size="contentsFontSize"
          />
        </VBlock>

        <VBlock :padding="[19, 0, 0, 0]" :sort="Sort.left_top" :direction="Direction.column">
          <VP
            class="description"
            text="현금영수증 발행정보가 잘못된 경우 자진발급 처리됩니다."
            :size="14"
            :color="TextColor.gray2"
          />
          <VP
            class="description"
            text="자세한 내용은 자주 묻는 질문을 참고해주세요."
            :size="14"
            :color="TextColor.gray2"
          />
        </VBlock>
      </VBlock>
    </VBlock>
  </VModal>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VP from '@/presentationals/v2/components/layouts/atoms/VP'
import VSpan, { TextColor, TextWeight, TextType } from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VStockButton, { StockButtonType } from '@/presentationals/v2/components/layouts/atoms/VStockButton'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal, { ModalType } from '@/presentationals/v2/components/layouts/molecules/VModal'

import { Action } from '../../../../plugins/AppManager'

export default {
  name: 'ModalCashReceipt',
  components: {
    VP,
    VSpan,
    VStockButton,
    VButton,
    VBlock,
    VModal
  },
  computed: {
    appVersion() {
      return this.$store.getters.appVersion
    },
    currentReceiptTabContent() {
      return this.receiptTabContents[this.receiptTabIndex]
    },
    receiptEntryLines() {
      return [
        {
          title: '현금영수증 금액',
          text: this.currentReceiptTabContent.issuanceAmount
        },
        {
          title: '결제일자',
          text: this.currentReceiptTabContent.approvalDateTime
        },
        {
          title: '현금영수증 종류',
          text: this.currentReceiptTabContent.typeName
        },
        {
          title: '발행정보',
          text: this.currentReceiptTabContent.issuanceNumber
        },
        {
          title: '승인정보',
          text: this.currentReceiptTabContent.approvalNumber
        },
        {
          title: '가맹점정보',
          text: this.currentReceiptTabContent.corporateName
        },
        {
          title: '사업자 등록번호',
          text: this.currentReceiptTabContent.corporateNumber
        }
      ]
    },
    hasTab() {
      return this.receiptTabContents.length > 1
    }
  },
  async created() {
    const { paymentKey } = this.$route.params

    const { result } = await this.$store.dispatch('myOrderHistoryDetailV2/loadCashReceipt', paymentKey)
    this.receiptTabContents = result.receipts

    if (screen.width <= 320) {
      this.contentsFontSize = 15
    }
  },
  mounted() {
    const { appVersion } = this.$store.getters
    this.$store.commit('hideNavigationBar', { appVersion })
  },
  beforeDestroy() {
    const { appVersion } = this.$store.getters
    this.$store.commit('showNavigationBar', { appVersion })
  },
  methods: {
    onOK() {
      this.$appManager.action(Action.CLOSE)
    }
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,
      ModalType,
      StockButtonType,
      receiptTabContents: [],
      receiptTabIndex: 0,
      contentsFontSize: 16
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.cash-receipt-wrapper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: $background-white;
  overflow: auto;

  .cash-receipt {
    width: 100%;
    height: 100vh;
  }

  .cash-receipt-header-wrapper {
    width: 100%;
    background: #fff;
    position: fixed;

    .cash-receipt-header {
      padding: 10px 15px 10px 15px;
      align-items: center;
      box-sizing: border-box;

      .stock-wrapper {
        width: 24px;
        height: 24px;
      }

      .text {
        height: 19px;
        vertical-align: middle;
      }

      .blank {
        width: 30px;
      }
    }

    .cash-receipt-tab {
      border-bottom: 1px solid #d7d7d7;
      padding: 0 15px;

      .tab-button {
        width: 50%;
        height: 39px;
        color: #888;
        font-size: 16px;
        position: relative;

        &.active {
          color: #222;
          font-weight: 700;
          &::after {
            content: '';
            width: 60px;
            height: 4px;
            background: #222;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
  }

  .cash-receipt-header-filler {
    flex-shrink: 0;
  }

  .field-row {
    display: flex;
    align-items: center;
    border-bottom: 1px solid $light-gray-5;
    height: 60px;
    box-sizing: border-box;

    @media screen and (max-width: 320px) {
      height: 55px;
    }

    .title {
      width: 117px;
      color: $dark-gray;
    }

    .text {
      width: calc(100% - 117px);
      color: $dark-gray;
    }
  }

  .description {
    line-height: 19px;
  }
}
</style>
